export let uniqueUserId = null;

const loadUniqueUserIdCallback = () => {
    Fingerprint2.get((components) => {
        components.availableScreenResolution = components.screenResolution = components.canvas = {};
        uniqueUserId = Fingerprint2.x64hash128(components.map(function (component) { return component.key + '_' + component.value; }).join(''), 31);
        if(!localStorage.getItem('uniqueUserId')) {
            $.post('/setUniqueUserId', {uniqueUserId: uniqueUserId, '_token': $('meta[name="csrf-token"]').attr('content')}, (ans) => {
                sessionStorage.setItem('uniqueUserId', uniqueUserId);
                localStorage.setItem('uniqueUserId', uniqueUserId);
                if(window.location.pathname.substring(1).split('/').length > 5) {
                    window.location.reload();
                }
            });
        }
    })
}

if (window.requestIdleCallback) {
    requestIdleCallback(() => {
        loadUniqueUserIdCallback()
    })
} else {
    setTimeout(() => {
        loadUniqueUserIdCallback()
    }, 500)
}
